import { Channel, ChannelFull } from "./api/models";

type ChannelMapToFullType = Record<Channel, ChannelFull>;
type ChannelMapToShortType = Record<ChannelFull, Channel>;

export const ChannelMapToFull: ChannelMapToFullType = {
  INB: "Inbound",
  OUT: "Outbound",
  RES: "Research",
  TRN: "Transfer",
  COR: "Correspondence",
};

export const ChannelMapToShort: ChannelMapToShortType = {
  Inbound: "INB",
  Outbound: "OUT",
  Research: "RES",
  Transfer: "TRN",
  Correspondence: "COR",
};
